module.exports = __webpack_public_path__ + "static/Guy Hochman-c967235970a5292ef2eb523e1e64655f.png";